<template>
  <div>
    <section class="orep-header mont" v-if="$route.name !== 'property-inspector-final' && $route.name !== 'property-inspector-representation'">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img v-if="getApplicantType === 'IBD'" src="../../../public/assets/images/ibdpro-logo.svg" class="logo-ibdpro" alt="Logo">
        <img v-else-if="getApplicantType === 'RWS'" src="../../../public/assets/images/rws-logo.svg" class="logo-ibdpro" alt="Logo">
        <img v-else-if="getApplicantType === 'SPMGA'" src="../../../public/assets/images/spmga-logo.svg" class="logo-spmga" alt="Logo">
        <img v-else-if="getApplicantType === 'RISKPRO'" src="../../../public/assets/images/riskpro-logo.svg" class="logo-riskpro" alt="Logo">
        <img v-else src="../../../public/assets/images/OREPInsuranceShield_new.png" class="logo" alt="Logo">
        <span v-if="getApplicantType === 'OREP'" class="logo-text text-uppercase">CALIF. LIC. #0K99465</span>

      </section>
    </section>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "property-inspector",
    computed: {
      quote() {
        return this.$store.state.homeInspector.quote;
      },
      state() {
        return this.$store.state.homeInspector;
      },
      errorMsg() {
        return this.$store.state.homeInspector.errorMsg;
      },

      getApplicantType() {
        var route = this.$route.path;
        var first = route.substring(0, route.lastIndexOf("/") + 1);
        if (first === '/portal/property-inspector-ibd/' || first === '/portal/property-inspector-IBD/'|| this.quote.customer.partnerName === 'IBD'){
          return 'IBD';
        }else if (first === '/portal/property-inspector-rws/' || first === '/portal/property-inspector-rws/'|| this.quote.customer.partnerName === 'RWS'){
          return 'RWS';
        }else if (first === '/portal/property-inspector-spmga/' || first === '/portal/property-inspector-spmga/'|| this.quote.customer.partnerName === 'SPMGA'){
          return 'SPMGA';
        }
        else if (first === '/portal/property-inspector-new/' || first === '/portal/property-inspector-NEW/'|| this.quote.customer.partnerName === 'NEW'){
          return 'NEW';
        }
        else if (first === '/riskpro/property-inspector/' || first === '/RISKPRO/property-inspector/' ||this.quote.customer.partnerName === 'RISKPRO'){
          return 'RISKPRO';
        }
        else {
          return 'OREP';
        }
      },
    },
    data() {
      return {
        isActive: false
      };
    },
    methods: {
      hamSpin() {
        this.isActive = !this.isActive;
      }
    }
  }
</script>
